<template>
  <PageContent class="batch-edit-wrapper">
    <span class="summary-title">
      Please review and confirm your submission
    </span>
    <PanelV2
      type="w6"
      title="Personal Information"
      @nextClick="saveForms()"
      mode="edit"
    >
      <template v-slot:title-solt>
      </template>
      <template v-slot:content-solt>
        <MerchantForm
          v-model="merchantForm"
          ref="merchantForm"
        />
        <hr class="divider" />
        <div class="form-title">
          <span>Home Address</span>
        </div>
        <HomeAddressForm
          v-model="homeAddressForm"
          ref="homeAddressForm"
          :selectOptions="selectOptions"
        />
        <hr class="divider" />
        <BasicInfoForm
          v-model="basicInfoForm"
          ref="basicInfoForm"
          :selectOptions="selectOptionsData"
        />
      </template>
    </PanelV2>

  </PageContent>
</template>

<script>
  import API from "@/api";
  import MerchantForm from "@/pc/forms/BDOMerchantFormLite.val";
  import HomeAddressForm from "@/pc/forms/SolePropD.val";
  import BasicInfoForm from "@/pc/forms/SolePropE.val";
  import {provinceData, cityData} from "../../common-data/config";
  import barangayData from "../../common-data/barangay-data";
  import citSelectyData from "../../common-data/city_select_data";
  import {
    // birthCountryOptions,
    citizenShipOptions,
  } from "../../locales/select-data";

  export default {
    name: 'EditPersonalInfo',
    pRouter: 'App',
    components: {
      MerchantForm,
      HomeAddressForm,
      BasicInfoForm,
    },
    data() {
      return {
        merchantForm: {
          email: '', 
          firstName: '', 
          middleName: '', 
          lastName: '', 
          suffix: '', 
          mobile: '',
        },
        homeAddressForm: {
          streetAddress: '', 
          subdivision: '',
          province: '', 
          city: '', 
          barangay: '', 
          zipCode: '',
        },
        basicInfoForm: {
          month: '',
          day: '',
          year: '',
          tin: '',
          countryOfBirth: '',
          cityOfBirth: '',
          citizenship: '',
          birthday: '',
        },
        businessAddress: {
          sameAasHomeAddress: '2',
          streetAddress: '', 
          subdivision: '',
          province: '', 
          city: '', 
          barangay: '', 
          zipCode: '',
        },
        status1: true,
        status2: true,
        status3: true,
        status4: true,
        selectOptions: {
          province: provinceData,
          city: [],
          barangay: [],
          zipCode: [],
        },
        selectOptionsData: {
          countryOfBirth: citizenShipOptions,
          cityOfBirth: citSelectyData,
          citizenship: citizenShipOptions,
        },
      }
    },
    watch: {
      'homeAddressForm.province': function(val) {
        if (!this.status1) {
          this.$set(this.homeAddressForm, 'city', '')
        } else {
          this.status1 = false
        }
        this.selectOptions.city = val ? cityData[val] : []
      },
      'homeAddressForm.city':function(val) {
        if (!this.status2) {
          this.$set(this.homeAddressForm, 'barangay', '')
        } else {
          this.status2 = false
        }
        this.selectOptions.barangay = barangayData[val || ''] || []
      },
      'homeAddressForm.barangay':function(val) {
        if (!this.status3) {
          this.$set(this.homeAddressForm, 'zipCode', '')
        } else {
          this.status3 = false
        }
        if (this.selectOptions.barangay.length > 0 && val) {
          const data = this.selectOptions.barangay.filter(value => value.value === val)[0].zipCode
          this.$set(this.homeAddressForm, 'zipCode', data[0])
          // this.selectOptions.zipCode = data.map(item => ({ label: item, value: item }))
        } else {
          // this.selectOptions.zipCode = []
          this.$set(this.homeAddressForm, 'zipCode', '')
        }
      },
      "basicInfoForm.countryOfBirth": function(val) {
        console.info(val)
        if (!this.status4) {
          this.$set(this.basicInfoForm, 'cityOfBirth', '')
        } else {
          this.status4 = false
        }
        if(val !== 'Philippines'){
          this.selectOptionsData.cityOfBirth = [{
            "label": "Others",
            "value": "Others"
          },]
        }else{
          this.selectOptionsData.cityOfBirth = citSelectyData
        }
      },
    },
    created() {
      API.getBdoProcessData({
        token: this.getCookieItem('token'),
        pageNo: '999',
      }).then((res) => {
        if (res.success) {
          const {
            personalInfo,
            homeAddress,
            additionalDetails,
            businessAddress,
          } = res.obj;
          const birthday = `${additionalDetails.year}-${additionalDetails.month}-${additionalDetails.day}`;
          Object.assign(this.merchantForm, personalInfo);
          Object.assign(this.homeAddressForm, homeAddress);
          Object.assign(this.basicInfoForm, {...additionalDetails, birthday});
          Object.assign(this.businessAddress, businessAddress);
        }
      })
    },
    mounted() {
      const email = document.getElementsByTagName('input')[6]
      email.readOnly = 'readOnly'
      email.style.cssText = "cursor: not-allowed;background-color: #F5F7FA;border-color: #E4E7ED;color: #C0C4CC;"
    },
    methods: {

      saveForms() {
        const {
          merchantForm,
          homeAddressForm,
          basicInfoForm,
        } = this.$refs

        Promise.all([
            merchantForm.$refs.appForm,
            homeAddressForm.$refs.appForm,
            basicInfoForm.$refs.appForm
          ].map(form => {

            return new Promise((reslove) => {
              form.validate(valid => {
                reslove(valid);
              })
            })
          })).then((res) => {
            const [res1, res2, res3] = res;
            if (res1 && res2 && res3) {
              // const [year, month, day] = this.basicInfoForm.birthday.split('-');
              const params = {
                token: this.getCookieItem('token'),
                pageNo: `0,3,4`,
                personalInfo: this.merchantForm,
                homeAddress: this.homeAddressForm,
                additionalDetails: {
                  ...this.basicInfoForm
                },
              };
              // 商户地址开启同步个人地址时同时上送地址信息
              if(this.businessAddress.sameAasHomeAddress === '1') {
                params.pageNo += `,6`;
                params.businessAddress = {
                  ...this.businessAddress,
                  ...this.homeAddressForm,
                };
              }
              API.editBdoProcess(params).then(res => {
                if (res.success) {
                  window.history.go(-1);
                }
              })
            }
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .panel-v2.content-area {
      margin: 16px 0;
  }
</style>
